import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';
import type { OmitStylesComponentProps } from '../../types';

export const toggleVariants = cva(
    'rocco-toggle inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
    {
        variants: {
            variant: {
                default: 'bg-transparent',
                outline:
                    'border border-input bg-transparent hover:bg-accent hover:text-accent-foreground',
            },
            size: {
                default: 'h-10 px-3',
                sm: 'h-9 px-2.5',
                lg: 'h-11 px-5',
            },
            shrink: {
                true: 'shrink',
                false: 'shrink-0',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
            shrink: false,
        },
    },
);

export const Toggle = React.forwardRef<
    React.ElementRef<typeof TogglePrimitive.Root>,
    OmitStylesComponentProps<typeof TogglePrimitive.Root> &
        VariantProps<typeof toggleVariants>
>(({ variant, size, ...props }, ref) => (
    <TogglePrimitive.Root
        ref={ref}
        className={cn(toggleVariants({ variant, size }))}
        {...props}
    />
));

Toggle.displayName = TogglePrimitive.Root.displayName;
